import { getUsers } from "services/apiMiddleware";
import { t } from "../../i18n";

const users = {
  state: {
    isLoading: false,
    error: null,
    items: [],
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadSuccess: (state, users) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: users,
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
    setIsLoading: (state, isLoading) => {
      return {
        ...state,
        isLoading,
      };
    },
  },
  effects: (dispatch) => ({
    async init() {
      try {
        dispatch.users.loadStart();
        const { data } = await getUsers();
        dispatch.users.loadSuccess(data);
      } catch (error) {
        console.error(error);
        dispatch.users.failure(t("users_load_error", { ns: "common" }));
      }
    },
    setLoading(isLoading) {
      dispatch.users.setIsLoading(isLoading);
    },
  }),
};

export default users;
